export const opcoesCustosVariaveis = [
  "Energia",
  "Água",
  "Combustível",
  "Manutenção",
  "Materiais de Limpeza",
  "Transporte"
];

export const opcoesCustosFixos = [
  "Aluguel",
  "Internet",
  "Telefone",
  "Seguros",
  "Contabilidade",
  "Licenças e Taxas"
];
